import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import urlJoin from 'url-join';
import { ROUTE_TOKEN_TAX_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable({
  providedIn: 'root'
})
export class LegalEntitiesService {

  constructor(
    private http: HttpClient
  ) {}

  getLegalEntities(tenantId: string): Observable<any> {
    const url = urlJoin(ROUTE_TOKEN_TAX_GATEWAY_URL, `tax-transparency/v1/tenants/${encodeURI(tenantId)}/companies/legal-entities`);
    return this.http.get(url);
  }
}
